interface IMarkerSizes {
  [key: string]: {
    [key:string]: number
  }
}

const markerSizes:IMarkerSizes = {
  small: {
    width: 15,
    height: 22
  },
  medium: {
    width: 31,
    height: 45
  },
  large: {
    width: 62,
    height: 90
  }
}

export {
  markerSizes
}
